export default __webpack_public_path__ + "static/media/badge.a25cc209.svg";